import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { endPoints } from "../../config/end-points";
import useHttp from "../../hooks/use-http";
import { authActions } from "../../store/auth";
import NotFound from "../404";
import UserForm from "./User-Form";

const CreateUser = () => {
  const { user_id } = useParams();
  const [userDetail, setUserDetail] = useState();
  const { sendRequest } = useHttp();
  const user_roles = useSelector((state) => state.auth.roles);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(authActions.setLoaderStatus({ status: true }));
    if (user_id) {
      document.title = `Update User`;
      sendRequest(
        {
          url: endPoints.getUser + "/" + user_id,
          method: "GET",
        },
        (response) => {
          console.log(response.id);
          if (response.id) {
            // setUserDetail("Hello");
            setUserDetail(response);
          }
          dispatch(authActions.setLoaderStatus({ status: false }));
        }
      );
    } else {
      document.title = `Create User`;
      dispatch(authActions.setLoaderStatus({ status: false }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_id]);
  return (
    <>
      {user_roles.role_id === 1 ? (
        <NotFound />
      ) : (
        <section className="mid_wrap">
          <div className="container">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-4 pb-2">
                <li className="breadcrumb-item">
                  <Link to="/">Dashboard</Link>
                </li>
                <li className="breadcrumb-item " aria-current="page">
                  <Link to="/users">Users</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Create New User
                </li>
              </ol>
            </nav>
            <div className="row d-flex justify-content-center ">
              <div className="col-md-8 ">
                <div className="bx_a">
                  <UserForm userDetail={userDetail} />
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default CreateUser;
